export const getDisplayableFileExtension = (fileExtension: string) => {
  return fileExtension.replace(/^(image|video|audio)\//, '.');
};

export const getDisplayableFileExtensionList = (fileExtensions: string[]) => {
  return fileExtensions.map(getDisplayableFileExtension);
};
